export const convertUtils = {
    buildMenuTree: (menuList) => {
        // 메뉴 맵 생성 (메뉴 번호로 빠르게 접근하기 위함)
        const menuMap = {};
        const rootMenus = [];
        
        // 1단계: 기본 정보로 맵 구성
        menuList.forEach(menu => {
            menuMap[menu.menu_id] = {
                ...menu,
                depth: 1,
                childCount: 0,
                children: []
            };
        });
        
        // 2단계: 부모-자식 관계 설정 및 깊이/자식 수 계산
        Object.values(menuMap).forEach(menu => {
            if (menu.parent_id && menuMap[menu.parent_id]) {
                const parent = menuMap[menu.parent_id];
                parent.children.push(menu);
                parent.childCount++;
                menu.depth = parent.depth + 1;
            } else {
                rootMenus.push(menu);
            }
        });

        // 3단계: sort_ord를 기준으로 정렬
        // 최상위 메뉴 정렬
        rootMenus.sort((a, b) => a.sort_ord - b.sort_ord);
        
        // 각 상위 메뉴의 하위 메뉴들도 정렬
        rootMenus.forEach(menu => {
            if (menu.children && menu.children.length > 0) {
                menu.children.sort((a, b) => a.sort_ord - b.sort_ord);
            }
        });
        
        return rootMenus;
    },
    numberMaxInput: (e, min, max) => {
        const value = Number(e.target.value)

        if(value > max){
            e.target.value = max
        }else if(value < min){
            e.target.value = min
        }
    },
    convertHexValue: (value) => {
        // 문자열 처리 (예: "AE", "0xC8")
        if (typeof value === 'string') {
            // 0x 제거, 공백 제거
            let cleaned = value.replace(/^0x/i, '').trim();
            if (cleaned.length % 2 !== 0 && cleaned.length < 3) cleaned = '0' + cleaned;
            return `0x${cleaned}`;
        }

        // 숫자 처리 (예: 200 → 0xC8)
        if (typeof value === 'number') {
            if (value < 0) input = 0; // 음수 방지
            let hex = value.toString(16).toLowerCase();
            if (hex.length % 2 !== 0 && hex.length < 3) hex = '0' + hex;
            return `0x${hex}`;
        }

        return '0x00'
    },
    /**
     * ble array 생성(index 3~17을 직접 호출 후 수정)
     * @param gubun(1: 진단기, 2: 전자약ch1, 3: 전자약ch2, 4: 전자약)
     * @param category(1: 명령, 2: 제어)
     * @return Array
     */
    generateBLEArray(gubun, category, param1 = 0x00, param2 = 0x00, param3 = 0x00, param4 = 0x00, param5 = 0x00, param6 = 0x00, param7 = 0x00, param8 = 0x00, param9 = 0x00, param10 = 0x000){
        let arr = new Array(20).fill(0x00)
        arr[0] = 0x28
        arr[1] = Number(gubun) || 0x01
        arr[2] = Number(category) || 0x01
        arr[3] = Number(param1) || 0x00
        arr[4] = Number(param2) || 0x00
        arr[5] = Number(param3) || 0x00
        arr[6] = Number(param4) || 0x00
        arr[7] = Number(param5) || 0x00
        arr[8] = Number(param6) || 0x00
        arr[9] = Number(param7) || 0x00
        arr[10] = Number(param8) || 0x00
        arr[11] = Number(param9) || 0x00
        arr[12] = Number(param10) || 0x00
        arr[19] = 0x29

        // 체크섬 계산 (2-18)
        let xor = 0x00;
        for (let i = 1; i <= 17; i++) {
            xor ^= arr[i];
        }

        arr[18] = xor

        return arr
    },
    convertWeight(input) {
        if (!input) return null;
        // let value = input.trim().toLowerCase();
        const value = String(input).trim()

        // 숫자 추출
        const numMatch = value.match(/(\d+(\.\d+)?)/);
        if (!numMatch) return null;

        let num = numMatch[1];

        // 단위가 포함되어 있지 않다면 자동으로 붙임
        if (!/kg|킬로|키로/.test(value)) {
            return `${num}kg`;
        }

        // 단위 통일
        return `${num}kg`;
    }
};
